import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import {AuthService} from "../auth/auth.service";
import {MatButton, MatButtonModule} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {Router, RouterLink} from "@angular/router";


@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIcon, RouterLink],
  templateUrl: './header.html',
  styleUrls: ['./header.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  userLabel: string | null = null;
  isLoggedIn = false;
  private subs: Subscription[] = [];

  constructor(public auth: AuthService, private cdr: ChangeDetectorRef, private router: Router) {}

  ngOnInit(): void {
    this.auth.authChanged.subscribe(v => this.isLoggedIn = v);
    this.auth.userLabel$.subscribe(l => this.userLabel = l);
  }

  ngOnDestroy(): void { this.subs.forEach(s => s.unsubscribe()); }
  login(): void { this.router.navigate(['/login'], {queryParams: {r: '/admin/dashboard'}}); }
  get dashboardLabel(): string {
    return this.auth.hasAnyRole(['ADMIN']) ? 'Administracija' : 'Moj profil';
  }
  goToDashboard(): void {
    if (this.auth.hasAnyRole(['ADMIN'])) {
      this.router.navigate(['/admin/approvals']);
      return;
    }
    this.router.navigate(['/admin/dashboard']);
  }
  logout(): void { this.auth.logout(); }
}
